<template>
  <div :class="['select', { 'is-invalid': showValidationError }]">
    <label v-if="showLabel" :for="inputId" class="form-label">
      <required v-if="required" />
      {{ label }}
    </label>
    <select :id="calculatedInputId" :value="value" :name="calculatedInputName"
            :class="['form-select select', {'is-invalid': showValidationError}]"
            @change="updateValue($event.target.value)" @focus="$emit('focus')">
      <option v-for="country in countryOptions" :key="country[0]" :value="country[1]">
        {{ country[0] }}
      </option>
    </select>
  </div>
</template>

<script>
import { inject } from 'vue'
import isPresent from '../../helpers/is-present'
import Required from '../required'
import WithInputIdAndName from '@/components/inputs/mixins/with-input-id-and-name'

export default {
  components: { Required },

  mixins: [ WithInputIdAndName ],

  props: {
    countryOptions: {
      type: Array,
      required: true
    },

    geoipHostname: {
      type: String,
      required: false
    },

    initializeWithGeoip: {
      type: Boolean,
      required: false,
      default: true
    },

    label: {
      type: String,
      required: false,
      default: function() { return inject('i18n').t('country') }
    },

    required: {
      type: Boolean,
      required: false,
      default: false
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    },

    value: {
      type: String,
      required: false
    }
  },

  emits: ['changed', 'focus'],

  data() {
    return {
      fieldName: 'country'
    }
  },

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  mounted() {
    if (this.initializeWithGeoip && isPresent(this.geoipHostname)) {
      // Q: Why not use our ajax helper?
      // A: It runs into some weird CORS issue trying to make this external request
      fetch(`https://${this.geoipHostname}/geoip`).then((resp) => {
        resp.json().then((jsonResponse) => {
          this.updateValue(jsonResponse.country_code.toUpperCase())
        })
      })
    }
  },

  methods: {
    updateValue(newValue) {
      this.$emit('changed', newValue)
    }
  }
}
</script>
